module.exports = __webpack_public_path__ + "img/77400.bab8c035.jpg";